export default  {
	builder: '',
	property: '',
	lot_type: '',
	xml_subdivision: '',
	xml_subdivision_number: '',
	status: '',
	feed: ''
}